export default String.raw`
// Typography
//Body:

@mixin body-2-regular {
    //styleName: Body/Body 2 - Regular;
    font-family: $fontFamily;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
}

@mixin body-2-medium {
    //styleName: Body/Body 2 - Medium;
    font-family: $fontFamily;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
}

@mixin body-2-semibold {
    //styleName: Body/Body 2 - Semibold;
    font-family: $fontFamily;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    text-align: left;
}

@mixin body-1-regular {
    //styleName: Body/Body 1 - Regular;
    font-family: $fontFamily;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
}

@mixin body-1-medium {
    //styleName: Body/Body 1 - Medium;
    font-family: $fontFamily;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
}

@mixin body-1-semi-bold {
    //styleName: Body/Body 1 - Semi Bold;
    font-family: $fontFamily;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
}

@mixin body-1-regular-underlined {
    //styleName: Body/Body 1 - Regular underlined;
    font-family: $fontFamily;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    text-decoration: underline;
}

@mixin body-3-medium {
    font-family: $fontFamily;
    font-size: 10px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
}

//Button:

@mixin button {
    //styleName: Button/Button;
    font-family: $fontFamily;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
}

//Headlines:

@mixin h1-headline {
    //styleName: Headlines/H1 Headline;
    font-family: $fontFamily;
    font-size: 32px;
    font-weight: 500;
    line-height: 40px;
    text-align: left;
}

@mixin h2-headline {
    //styleName: Headlines/H2 Headline;
    font-family: $fontFamily;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    text-align: left;
}

@mixin h3-headline {
    //styleName: Headlines/H3 Headline;
    font-family: $fontFamily;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
}

@mixin h4-headline {
    //styleName: Headlines/H4 Headline;
    font-family: $fontFamily;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
}

//Subtitle:

@mixin subtitle-regular {
    //styleName: Subtitle/Subtitle-Regular;
    font-family: $fontFamily;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
}

@mixin subtitle-medium {
    //styleName: Subtitle/Subtitle- Medium;
    font-family: $fontFamily;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
}

@mixin subtitle-2-medium {
    //styleName: Subtitle/Subtitle 2- Medium;
    font-family: $fontFamily;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
}

@mixin subtitle-bold {
    //styleName: Subtitle/Subtitle- Bold;
    font-family: $fontFamily;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: left;
}
`